var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingCheck2Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check_16_2px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1919 4.27801C13.5907 4.66014 13.6041 5.29316 13.222 5.69191L7.47199 11.6919C7.09491 12.0854 6.47219 12.1045 6.07172 11.7348L2.82172 8.7348C2.4159 8.3602 2.3906 7.72754 2.7652 7.32172C3.13981 6.9159 3.77246 6.89059 4.17829 7.2652L6.7071 9.59949L11.778 4.3081C12.1601 3.90935 12.7932 3.89588 13.1919 4.27801Z",
    fill: "#343A40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCheck2Px);
export default __webpack_public_path__ + "static/media/floating-check_2px.96d00b3cec59194b07e474c7a940e380.svg";
export { ForwardRef as ReactComponent };